import { SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";

const RestorePayment = ({
    setIsRestorePayment,
    selectedData,
    restorePaymentLoading,
    restorePaymentMutate,
}) => {

    const handleSubmit = ({ setSubmitting }) => {
        restorePaymentMutate({
            id: selectedData?.id,
        });
    };

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setIsRestorePayment}
            title="Restore Payment"
        >
            <div className="w-full px-4 py-4">
                <p className="text-gray-700 mb-4">Are you sure you want to restore this payment?</p>

                <ul className="list-disc pl-4 mb-4 space-y-2 text-gray-600">
                    <li>This will remove the payment from collection & ledger.</li>
                    <li>The due amount will be shown again in the tenant's account.</li>
                    <li>You'll be able to edit and repay it correctly if required.</li>
                </ul>
            </div>

            <div className="w-full flex justify-between space-x-2 mb-4">
                <SideCancelBtn type="button" onClick={() => setIsRestorePayment(false)}>
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    type="submit"
                    disabled={restorePaymentLoading}
                    onClick={handleSubmit}
                >
                    {restorePaymentLoading ? "Restoring..." : "Confirm Restore"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

export default RestorePayment;